import { estudianteTypes } from "../../types/estudianteTypes"
import { formatoTypes } from "../../types/formatoTypes"
import { resetValidacion, valida_DNI, obtiene_formatos, valida_Beneficiario } from "../actions/estudianteActions"
import { validaDNI, obtieneFormatos, validaBeneficiario, obtieneFormatosCompletados } from "../../helpers/estudianteHelper"
import { Mensaje } from "../../controls/Mensaje"
import { logErrors, MessagesError } from "../../logErrors"
import { getFormatos } from "../actions/formatoActions"
import { ProcesoStart, ProcesoEnd } from "../../controls/Proceso"
import { resetDistritos, resetProvincias, resetRegiones } from "../actions/ubigeoActions"
import { resetInstituciones } from "../actions/instEducativaActions"
import { getRegionesBD } from "./ubigeoThunk"

export const validarDNI = ( estudiante ) => {
    return async( dispatch, getState ) => {
        try {
            const { dni, message, severity } = getState().estudiante

           // if (estudiante.dni === dni && severity === 'success' && message !== '') return;
            dispatch( valida_DNI() )
            
            const response = await validaDNI( estudiante )

            console.log(response)
            if ( response.Validacion !== '' ){
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error', isValidated: true, lista_formato: response.Data } } );
                Mensaje( response.Validacion, 'Aviso', 'info' )
                dispatch( resetValidacion( { isValidated: false, message: '', severity: '', lista_formato: response.Data }) )
            }
            else{
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_COMPLETE, 
                    payload: { ...estudiante, message: 'Se validó con éxito', severity: 'success', isValidated: true } } );
                dispatch( { type: estudianteTypes.ESTUDIANTE_GET_FORMATOS, 
                    payload: response.Data } );
                dispatch( { type: formatoTypes.FORMATO_GET_COMPLETE, 
                    payload: response.Data } );
            }
            console.log('estud63', response.Validacion)

            if ( response.Validacion == 'El estudiante, ya se encuentra registrado.' ){
                 setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }

        } catch ( e ) {
            dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}

export const obtenerFormatos = ( estudiante ) => {
    return async( dispatch, getState ) => {
        try {
            // dispatch( obtiene_formatos( { isLoading: true, message: '' } ) )

            const response = await obtieneFormatos( estudiante )

            if ( response.Validacion !== '' ){
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                // dispatch( { type: estudianteTypes.ESTUDIANTE_GET_FORMATOS, 
                //     payload: response.Data } );
                dispatch( { type: formatoTypes.FORMATO_GET_COMPLETE, 
                    payload: response.Data } );
            }
             console.log('estud64', response.Validacion)
            // dispatch( obtiene_formatos( { isLoading: false, message: response.Validacion } ) )

        } catch ( e ) {
            dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}


export const obtenerFormatosCompletados = ( estudiante ) => {
    return async( dispatch, getState ) => {
        try {
            // dispatch( obtiene_formatos( { isLoading: true, message: '' } ) )

            const response = await obtieneFormatosCompletados( estudiante )

            if ( response.Validacion !== '' ){
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'error' } } );
            }
            else{
                // dispatch( { type: estudianteTypes.ESTUDIANTE_GET_FORMATOS, 
                //     payload: response.Data } );
                dispatch( { type: formatoTypes.FORMATO_GET_COMPLETE, 
                    payload: response.Data } );
            }
            
            // dispatch( obtiene_formatos( { isLoading: false, message: response.Validacion } ) )

        } catch ( e ) {
            dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}


export const validarBeneficiario = ( estudiante ) => {
    return async( dispatch, getState ) => {
        try {
            // dispatch( valida_Beneficiario() )
            
            ProcesoStart()

            const response = await validaBeneficiario( estudiante )

            console.log(response)
            if ( response.Validacion !== '' ){
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: { message: response.Validacion, severity: 'success', isValidated: true, beneficiario: response.Data != 0 } } );
                Mensaje( response.Validacion, 'Aviso', 'info' )
                dispatch( resetValidacion( { isValidated: false, message: '', severity: '' }) )
            }
            else{
                dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_COMPLETE, 
                    payload: { ...estudiante, message: 'Se validó con éxito', severity: 'success', isValidated: true, beneficiario: response.Data != 0 } } );
                    
                ProcesoEnd();
            }

        } catch ( e ) {
            dispatch( { type: estudianteTypes.ESTUDIANTE_SAVE_ERROR, payload: [] } );
            const err = logErrors( e )
            Mensaje( err.Message, err.Type )
            
        }
        
    }
}




